export default __webpack_public_path__ + "static/media/headphones-icon.71f3d1bc.png";